'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconAdd, iconAddTag } from '@ni/nimble-components/dist/esm/icons/add';
import { wrap } from '../../utilities/react-wrapper';

export type { IconAdd };
export { iconAddTag };
export const NimbleIconAdd = wrap(IconAdd);